<template>
    <nav class="mobile-nav d-lg-none">
       <nav-component/>
    </nav>
</template>

<script>
    import NavComponent from "./NavComponent";
    export default {
        name: "NavMobile",
        components: {NavComponent}
    }
</script>

<style scoped>

</style>